<template>
  <v-container class="grey lighten-5">

    <v-card v-if="isErrorParam" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">マイ機器情報にアクセスできません</span>
      </div>
      <p class="caption">
        マイ機器情報にアクセスできません。<br>
        <br>
        すでに削除されているマイ機器情報を開こうとしているか、他の事業所のマイ機器情報にアクセスしています。<br>
        もう一度マイ機器一覧からアクセスしてください。<br>
      </p>
      <v-btn icon :to="{ path: '/mymachinelist' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>マイ機器一覧に戻る
    </v-card>

    <div v-if="!isErrorParam" class="my-3" >
      <!-- <v-btn icon :to="{ path: '/mymachine', query: { id: this.machineid }}"> -->
      <v-btn icon @click="$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <template v-if="this.$store.state.operatingCompany.AnalizeTypeGroup=='航空機'">
        <span class="display-1 pl-3" id="title">{{AnalizeTypeCategory}} の</span>
      </template>
      <span class="display-1 px-3" id="title">分析サンプルの{{ samplingmode }}</span>
    </div>
<!--
    <v-row class="mx-3">
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
        <informationList></informationList>
      </v-col>
    </v-row>
-->
    <v-form v-if="!isErrorParam" ref="sampling_form">
      <v-card class="pa-2">
        <v-card-title class="title px-3 my-0">
        選択中のマイ機器情報
        </v-card-title>
        <v-card-subtitle class="caption px-3">
        選択中のマイ機器の情報です。変更が必要な場合は、メニューより変更してください
        </v-card-subtitle>

        <v-card outlined class="mx-md-3 mx-sm-1">


        <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
          <template v-if="AnalizeTypeCategory == '一般'">
            <span class="caption mx-3">{{getItemName('マイ機器名')[AnalizeTypeCategory+'message']}}:</span>
            <span class="d-flex d-sm-none"></span>
            <span class="title font-weight-bold" id="card-title">{{Name}}</span>
            <span class="d-flex d-sm-none"></span>
            <span class="caption mx-3">{{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'message']}}:</span>
            <span class="d-flex d-sm-none"></span>
            <span class="title font-weight-bold">{{ CustomerMachineID }}</span>
          </template>
          <template v-else-if="AnalizeTypeCategory == '航空機' && mountedMachine">
            <span class="caption mx-3">{{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']}}:</span>
            <span class="d-flex d-sm-none"></span>
            <span class="title font-weight-bold" id="card-title">{{mountedMachine.Name}}</span>
            <span class="d-flex d-sm-none"></span>
            <span class="caption mx-3">{{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'message']}}:</span>
            <span class="d-flex d-sm-none"></span>
            <span class="title font-weight-bold">{{ CustomerMachineID }}</span>
          </template>
          <template v-else>
            <span class="caption mx-3">{{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']}}:</span>
            <span class="d-flex d-sm-none"></span>
            <span class="title font-weight-bold" id="card-title">{{Name}}</span>
            <span class="d-flex d-sm-none"></span>
            <span class="caption mx-3">{{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'message']}}:</span>
            <span class="d-flex d-sm-none"></span>
            <span class="title font-weight-bold">{{ CustomerMachineID }}</span>
          </template>

        </v-card-title>


        <v-card-text>
            <v-row dense class="pt-2 pb-0 pl-2">
              <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                <div class="subtitle-2 grey white--text font-weight-bold pl-2 ">
                  項目名
                </div>
              </v-col>
              <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                  項目名（補足）
                </div>
              </v-col>
              <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                  設定内容
                </div>
              </v-col>
            </v-row>

            <template v-if="AnalizeTypeCategory == '航空機'">
              <template v-if="!mountedMachine">
                <div class="subtitle-2 red--text font-weight-bold pl-2 mt-2 mb-2 ">
                  この装備品は機体に関連づいていません。<br>
                  機体に関連する情報（AIRCRAFT T.Tなど）は報告書に記載されません。
                </div>

              </template>
            <template v-else>

              <v-row dense class="pa-2 pt-0">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.Name}}
                    <template v-if="!mountedMachine.Name">-</template>
                  </div>
                </v-col>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.CustomerMachineID}}
                    <template v-if="!mountedMachine.CustomerMachineID">-</template>
                  </div>
                </v-col>
-->

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.MakerText}}
                    <template v-if="!mountedMachine.MakerText">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.ModelNumber}}
                    <template v-if="!mountedMachine.ModelNumber">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.PurchasedDate}}
                    <template v-if="!mountedMachine.PurchasedDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.TotalOperatingTime}} {{mountedMachine.TotalOperatingTimeUnitText}}
                    <template v-if="!mountedMachine.TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理日')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.OverhaulDate}}
                    <template v-if="!mountedMachine.OverhaulDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.SinceOverhaulTime}} {{mountedMachine.SinceOverhaulTimeUnitText}}
                    <template v-if="!mountedMachine.SinceOverhaulTime">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('搭載位置')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('搭載位置')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MountPosition}}
                    <template v-if="!MountPosition">-</template>
                  </div>
                </v-col>
                
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.MachineMemo}}
                    <template v-if="!mountedMachine.MachineMemo">-</template>
                  </div>
                </v-col>
              </v-row>
            </template>
            </template>
<!--
          </v-card-text>
        </v-card>
        <v-card outlined class="py-1 mt-3">
          <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
            マイ機器（装備品）情報
          </v-card-title>
          <v-card-text>
              <v-row dense class="pt-2 pb-0 pl-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2 ">
                    項目名
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                    報告書項目名
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                    設定内容
                  </div>
                </v-col>
              </v-row>
-->

              <v-row dense class="pa-2 pt-0">
                <template v-if="AnalizeTypeCategory == '一般'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名')[AnalizeTypeCategory+'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{Name}}
                      <template v-if="!Name">-</template>
                    </div>
                  </v-col>
                </template>

                <template v-if="AnalizeTypeCategory == '航空機' && !mountedMachine">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名_機体')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{Name}}
                      <template v-if="!Name">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{CustomerMachineID}}
                    <template v-if="!CustomerMachineID">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機械名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機械名')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{Equipment}}
                    <template v-if="!Equipment">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory=='一般'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('顧客名')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('顧客名')[AnalizeTypeCategory+'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1 font-weight-bold pl-2">
                      {{CustomerName}}
                      <template v-if="!CustomerName">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MakerText}}
                    <template v-if="!MakerText">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{ModelNumber}}
                    <template v-if="!ModelNumber">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{PurchasedDate}}
                    <template v-if="!PurchasedDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{TotalOperatingTime}} {{TotalOperatingTimeUnitText}}
                    <template v-if="!TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory=='航空機'">

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理日')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理日')[AnalizeTypeCategory+'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{OverhaulDate}}
                      <template v-if="!OverhaulDate">-</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{SinceOverhaulTime}} {{SinceOverhaulTimeUnitText}}
                      <template v-if="!SinceOverhaulTime">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('システム油量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('システム油量')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SystemOil}} {{SystemOilUnitText}}
                    <template v-if="!SystemOil">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('前回分析依頼日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('前回分析依頼日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{LatestOrderAt}}
                    <template v-if="!LatestOrderAt">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('前回分析依頼番号')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('前回分析依頼番号')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{LatestOrderNumber}}
                    <template v-if="!LatestOrderNumber">-</template>
                  </div>
                </v-col>

<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MachineMemo}}
                    <template v-if="!MachineMemo">-</template>
                  </div>
                </v-col>
-->
              </v-row>

              <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilTypeCategoryText}}／{{OilTypeText}} {{OilPropertyText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilmakerText}}／{{OilModelNumber}} {{OilGradeText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChangeDate}}
                    <template v-if="!OilChangeDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChange}} {{OilChangeUnitText}}
                    <template v-if="!OilChange">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilUsageTime}} {{OilUsageTimeUnitText}}
                    <template v-if="!OilUsageTime">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory=='航空機'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用')[AnalizeTypeCategory+'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      <template v-if="UseFilter == undefined">使用していない</template>
                      <template v-else-if="!UseFilter">使用していない</template>
                      <template v-else-if="UseFilter">使用している</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用時間')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用時間')[AnalizeTypeCategory+'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{FilterUsageTime}} {{FilterUsageTimeUnitText}}
                      <template v-if="!FilterUsageTime">-</template>
                    </div>
                  </v-col>
                </template>
              </v-row>
<!--
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('サンプル採取場所')[AnalizeTypeCategory+'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{SamplingPlace}}
                      <template v-if="!SamplingPlace">-</template>
                    </div>
                  </v-col>
                </template>
              </v-row>
-->
<!--
          </v-card-text>
        </v-card>
-->




            <span class="caption grey--text text--darken-1">詳細情報の表示</span>
            <v-btn
              icon
              @click="show1 = !show1"
            >
              <v-icon>{{ show1 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          <v-expand-transition>
            <div v-show="show1">
              <v-divider></v-divider>
              <v-row class="px-3">
                <v-col cols="12" md="12" v-if="isHazardousMaterials==1">
                  <span class="caption">危険物の内容</span>
                  <v-textarea v-model="HazardousMaterialsDetail" dense readonly filled></v-textarea>
                </v-col>
              </v-row>
              <v-row class="px-3">
                <v-col cols="12" md="12" densa>
                  <span class="caption">マイ機器メモ</span>
                  <v-textarea v-model="MachineMemo" dense filled readonly></v-textarea>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>

          <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white" z-index="1">
            <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
          </v-overlay>
        </v-card-text>

        </v-card>

        <v-card class="mt-3" flat>
          <v-card-title class="headline" id="card-title">
            <v-chip color="amber darken-1" class="font-weight-bold">1</v-chip>
              オイル分析・診断依頼内容
          </v-card-title>

          <v-row dense class="mx-5">               
            <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
              <v-card flat outlined class="pa-3">
                <div class="subtitle-2 mb-2">
                  <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                  <span class="primary--text">分析・診断依頼内容について</span>
                </div>
                <p class="caption">
                  マイ機器情報で登録されている分析診断内容が入力されています。<br>
                  <br>
                  今回の分析・診断サービスの依頼内容に合わせて適宜依頼内容を変更してください。<br>
                </p>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-3 mx-5">
            <v-col cols="10" md="5" densa>
              <v-tooltip top color="grey darken-3">
                <template v-slot:activator="{ on }">
                  <v-autocomplete
                    v-on="on"
                    v-model="AnalizeTypeGroup"
                    @change="changeAnalizeTypeGroup"
                    label="分析方法"
                    :items="analizeTypeGroupList"
                    item-value="Value"
                    item-text="Text"
                  >
                  </v-autocomplete>
                </template>
                <span>
                分析方法を「社定法」か「公定法」かで選択してください。<br><br>
                <strong>社定法とは...</strong><br>
                弊社の独自法です。安価で短納期です。<br><br>
                <strong>公定法とは...</strong><br>
                公的規格に準拠した方法です。<br>
                ご依頼時に条件がありますので、事前に営業部へご連絡下さい。<br>
                          ※分析方法で公定法を選択し、公定法分析項目を選択された場合は、上記注意事項に沿ってご依頼ください。
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" md='1' align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
            <v-col cols="10" md="5" densa>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-select
                    v-on="on"
                    v-model="AnalizeType"
                    label="分析区分"
                    :items="analizeTypeList"
                    item-value="Value"
                    item-text="Text"
                    no-data-text="分析方法を選択してください。"                    
                    @change="changeAnalizeType"
                    readonly
                  >
                  </v-select>
                </template>
                <span class="wrap-text">{{getItemName('分析区分')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" md='1' dense>
            </v-col>
            <v-col cols="12" md="5" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-autocomplete
                    v-on="on"
                    clearable
                    v-model="AnalizeSet" 
                    :label="getItemName('セット分析')[AnalizeTypeCategory+'label']"
                    :items="analizeSetList"  
                    item-value="Value" 
                    item-text="Text" 
                    @change="changeAnalizeSet" 
                    no-data-text="この分析区分にはセット分析はありません"
                    @input="$v.AnalizeSet.$touch()"
                    :error-messages="AnalizeSetErrors"
                    :error="$v.AnalizeSet.$error"
                    :message="getItemName('セット分析')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:item="{ item }">
                      <v-checkbox
                      :input-value="AnalizeSet == item.Value"
                      />
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </template>
                <span class="wrap-text">{{getItemName('セット分析')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="11" v-show="isSelectAnalizeSet" dense>
              <v-select
                v-model="analizeSetItems"
                :items="analizeSetItems"
                item-value="Value"
                item-text="Text"
                label="セットに含まれる分析項目"
                multiple
                disabled
                append-icon=""
              >
                <template v-slot:selection="{ item }">
                  <v-chip>
                    <span>{{ item.Text }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="11" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-autocomplete
                    v-on="on"
                    v-model="AnalizeItems"
                    clearable
                    :items="activeAnalizeItemList"
                    item-value="Value"
                    item-text="Text"
                    :label="getItemName('個別分析項目')[AnalizeTypeCategory+'label']"
                    multiple
                    no-data-text="分析区分を選択してください。"
                    @change="changeAnalizeItems"
                    @input="$v.AnalizeItems.$touch()"
                    :error-messages="AnalizeItemsErrors"
                    :error="$v.AnalizeItems.$error"
                    :messages="getItemName('個別分析項目')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip
                        color="green darken-3"
                        text-color="white"
                      >
                        <span>{{ item.Text }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-checkbox
                      :input-value="AnalizeItems.includes(item.Value)"
                      />
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </template>
                <span class="wrap-text">{{getItemName('個別分析項目')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

          <template v-for="parent of Object.keys(AnalizeItemSub)">
            <v-row dense class="ml-2" v-bind:key="parent">
              <v-col cols=12 dense class="mb-0 pb-0">
                <v-icon color="blue">mdi-information</v-icon>
                <span class="font-weight-bold">「{{getAnalizeItemName(parent)}}」</span>が選択されました。以下の分析を追加することができます。
              </v-col>
              <v-col cols=12 dense class="ml-6 mb-0 pb-0">
                  <v-autocomplete
                    v-model="AnalizeItemSub[parent]" 
                    :items="analizeItemSubList[parent]" 
                    item-value="Value" 
                    item-text="Text" 
                    label="追加項目"
                    class="mb-0 pb-0"
                    @change="changeAnalizeItemSub"
                    :error-messages="AnalizeItemSubError[parent]"
                    multiple
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip
                        color="green darken-1"
                        text-color="white"
                      >
                        <span>{{ item.Text }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-checkbox
                      :input-value="AnalizeItemSub[parent].includes(item.Value)"
                      />
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
              </v-col>
            </v-row>
          </template>


          </v-row>

          <v-row v-show="standardValueList.length" class="mx-5 pt-0">
            <v-col cols="12" lg="3" md='12' sm='12' xs="12" class="align-start t mt-0 pt-0" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-switch
                    v-on="on"
                    class="ml-3"
                    v-model="isSwStandard"
                    label="報告書へ分析規格を記載"
                    @change="changeSwStandard"
                  >
                  </v-switch>
                </template>
                <span>分析・診断報告書に分析規格の記載をご希望される場合はチェックしてください。</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" lg="9" md='12' sm='12' xs="12" class="align-start"  v-show="standardValueList.length&&isSwStandard">
              <v-card flat outlined>
                <v-row class="px-4 pt-4" dense>
                  <v-col cols="8">
                    <div>
                      <v-icon color="blue">mdi-information-outline</v-icon>
                      <span class="caption">
                        ジャパン・アナリストで登録済みの分析規格の一覧から選択してください<br>
                        分析規格の追加をご希望の場合は、弊社担当営業までご連絡ください。
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="px-6" dense>
                  <v-col cols="10">
                    <v-tooltip top color="grey darken-2">
                      <template v-slot:activator="{ on }">
                        <v-select
                          v-on="on"
                          v-model="StandardValue" 
                          clearable 
                          @change="changeStandardValue" 
                          label="分析規格" 
                          :items="standardValueList" 
                          item-value="Value" 
                          item-text="Text" 
                          no-data-text="この分析区分には分析規格はありません"
                          @input="$v.StandardValue.$touch()"
                            :error-messages="StandardValueErrors"
                            :error="$v.StandardValue.$error"
                        >
                          <template slot='selection' slot-scope='data'>
                            {{ data.item.Text }} [ {{ data.item.StandardValue }} ]
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.Text }} [ {{ data.item.StandardValue }} ]
                          </template>
                        </v-select>
                      </template>
                      <span>ご希望の分析規格を選択してください。</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="2" align-self="center">
                    <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

            <!-- <v-col cols="12" md="4" densa>
              <v-select clearable v-model="StandardValue" label="分析規格" dense :items="standardValueList"  item-value="Value" item-text="Text" @change="changeStandardValue" no-data-text="この分析区分には分析規格はありません"></v-select>
            </v-col>
          </v-row> -->

          <v-row dense>
            <v-col cols="12" md="6" dense>
              <v-card flat>
                <v-card-title class="headline" id="card-title">
                  <v-chip color="amber darken-1" class="font-weight-bold">2</v-chip>
                  フィルター返却の要否
                </v-card-title>
              <v-radio-group v-model="Filter" class="ml-md-8 ml-2 pa-2" id="card-subject" @change="changeFilter" >
                <template v-slot:label>
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">汚染度（質量法）試験後の<strong>フィルター返却</strong></div>
                    </template>
                    <span class="wrap-text">{{getItemName('フィルター返却')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </template>
                <v-radio value="001">
                  <template v-slot:label>
                    <div id="card-subject">不要（0円）</div>
                  </template>
                </v-radio>
                <v-radio value="002">
                  <template v-slot:label>
                    <div id="card-subject">必要。<span  id="card-subject2">ラミネート加工 <strong class="black--text">あり（1,700円／検体）</strong></span></div>
                  </template>
                </v-radio>
                <v-radio value="003">
                  <template v-slot:label>
                    <div id="card-subject">必要。<span  id="card-subject2">ラミネート加工 <strong class="black--text">なし（600円／検体）</strong></span></div>
                  </template>
                </v-radio>
              </v-radio-group>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" dense>
              <v-card flat class="pa-md-2">

              <v-card-title class="headline" id="card-title">
                <v-chip color="amber darken-1" class="font-weight-bold">3</v-chip>
                  サンプル返却の要否
              </v-card-title>
                <v-radio-group v-model="Surplus" class="ml-md-8 ml-2 pa-2">
                  <template v-slot:label>
                    <v-tooltip top color="grey darken-2">
                      <template v-slot:activator="{ on }">
                        <div v-on="on"><strong>着払いで</strong>サンプルの返却</div>
                      </template>
                      <span class="wrap-text">{{getItemName('サンプル返却')[AnalizeTypeCategory+'description']}}</span>
                    </v-tooltip>
                  </template>
                  <v-radio value="0">
                    <template v-slot:label>
                      <div id="card-subject">返却を希望 しない</div>
                    </template>
                  </v-radio>
                  <v-radio value="1">
                    <template v-slot:label>
                      <div id="card-subject">返却を希望 <span  id="card-subject2">（返送には別途手数料が掛ります）</span></div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <br>
              </v-card>
            </v-col>
          </v-row>

          <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
            <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
          </v-overlay>

        </v-card>

        <v-card class="mt-3" flat>
          <v-card-title class="headline" id="card-title">
              <v-chip color="amber darken-1" class="font-weight-bold">4</v-chip>
              サンプル情報
          </v-card-title>
          <v-card-text>
            <v-row dense class="ml-4 mb-3">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                      <div v-on="on" class="body-1">
                        分析に必要なサンプル量
                      </div>
                  </template>
                  <span class="wrap-text">{{getItemName('必要オイル量')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
                <div class="title ml-2">
                  {{Require.toLocaleString()}} mL
                </div>
              </v-col>
              <v-col cols="12" lg="3" md="5" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <div class="body-1" v-on="on">
                      分析料金
                    </div>
                  </template>
                  <span class="wrap-text">{{getItemName('分析料金')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
                <div class="title ml-2">
                  {{analizeFee.toLocaleString()}} 円<span class="body-1">（税抜き）</span>
                </div>
              </v-col>
            </v-row>

            <v-row dense class="ml-6 mb-2">
              <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="SampleName"
                      :label="getItemName('サンプル名')[AnalizeTypeCategory+'label']"
                      :counter="getItemName('サンプル名')[AnalizeTypeCategory+'counter']"
                      @input="$v.SampleName.$touch()"
                      :error-messages="SampleNameErrors"
                      :messages="getItemName('サンプル名')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('サンプル名')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('サンプル名')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
              </v-col>
            </v-row>

            <v-row dense class="ml-6 mb-2">
              <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="SamplingAt"
                      :label="getItemName('採取日')[AnalizeTypeCategory+'label']"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      @input="$v.SamplingAt.$touch()"
                      :error-messages="SamplingAtErrors"
                      :messages="getItemName('採取日')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('採取日')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="SamplingAt"
                    @input="menu2 = false"
                    locale="ja"
                  ></v-date-picker>
                  </v-menu>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
              </v-col>

              <v-col cols="8" lg="1" md="2" sm='4' xs="8" dense class="pa-0">
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="BottleCount"
                      :label="getItemName('ボトル数')[AnalizeTypeCategory+'label']"
                      v-on="on"
                      @input="$v.BottleCount.$touch()"
                      :error-messages="BottleCountErrors"
                      :messages="getItemName('ボトル数')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('ボトル数')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('ボトル数')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
              </v-col>
            </v-row>

            <v-row dense class="ml-6 mb-2">
              <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-select
                      v-on="on"
                      v-model="OilCondition"
                      :label="getItemName('オイルの状態')[AnalizeTypeCategory+'label']"
                      :items="OilConditionList"
                      item-value="Value"
                      item-text="Text"
                      clearable
                      @change="changeOilCondition"
                      :messages="getItemName('オイルの状態')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('オイルの状態')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-select>
                  </template>
                  <span class="wrap-text">{{getItemName('オイルの状態')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <template v-if="AnalizeTypeCategory=='航空機'">
              <v-row dense class="ml-6 mb-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="SamplingBy"
                        :label="getItemName('採取者')[AnalizeTypeCategory+'label']"
                        :counter="getItemName('採取者')[AnalizeTypeCategory+'counter']"
                        @input="$v.SamplingBy.$touch()"
                        :error-messages="SamplingByErrors"
                        :messages="getItemName('採取者')[AnalizeTypeCategory+'message']"
                      >
                        <template v-slot:prepend-inner v-if="getItemName('採取者')[AnalizeTypeCategory+'証明書']">
                          <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <span class="wrap-text">{{getItemName('採取者')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2" xl="1" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                </v-col>
              </v-row>

              <v-row dense class="ml-6 mb-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="SamplingPlace"
                        :label="getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']"
                        counter=12
                        @input="$v.SamplingPlace.$touch()"
                        :error-messages="SamplingPlaceErrors"
                        :messages="getItemName('サンプル採取場所')[AnalizeTypeCategory+'message']"
                      >
                        <template v-slot:prepend-inner v-if="getItemName('サンプル採取場所')[AnalizeTypeCategory+'証明書']">
                          <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <span class="wrap-text">{{getItemName('サンプル採取場所')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row dense class="ml-4 mb-2">
                <v-col cols="12" lg="12" md="12" dense class="pa-0">
                  <v-checkbox
                    v-model="isOilChange"
                    class="agree-text" 
                    dense
                    label="オイル交換情報を報告書に印字する"
                  ></v-checkbox>   
                  <template v-if="isOilChange">
                    <v-row dense class="ml-6 mt-0">
                      <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="subtitle-2 grey lighten-3 pl-2">
                          {{getItemName('オイル交換有無')[AnalizeTypeCategory+'label']}}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="subtitle-2 grey lighten-3 pl-2">
                          {{getItemName('オイル交換有無')[AnalizeTypeCategory+'message']}}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="body-1  font-weight-bold pl-2">
                          EXCHANGE
                        </div>
                      </v-col>

                      <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="subtitle-2 grey lighten-3 pl-2">
                          {{getItemName('オイル交換量')[AnalizeTypeCategory+'label']}}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="subtitle-2 grey lighten-3 pl-2">
                          {{getItemName('オイル交換量')[AnalizeTypeCategory+'message']}}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="body-1  font-weight-bold pl-2">
                        {{OilChange}} {{OilChangeUnitText}}
                        </div>
                      </v-col>

                      <v-col cols="12" dense class="pa-0">
                        ※オイル交換情報を変更する場合はマイ機器（装備品）情報を変更して下さい。
                      </v-col>

                    </v-row>
                  </template>
                </v-col>
              </v-row>
            </template>

            <v-row dense class="ml-6 mt-6 mb-2">
              <v-col cols="12" lg="12" md="12" dense>
              <span class="caption">{{getItemName('サンプルメモ')[AnalizeTypeCategory+'label']}}（{{getItemName('サンプルメモ')[AnalizeTypeCategory+'message']}}）</span>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-textarea
                      v-model="SampleMemo"
                      v-on="on"
                      dense
                      filled
                      counter=60
                      @input="$v.SampleMemo.$touch()"
                      :error-messages="SampleMemoErrors"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('サンプルメモ')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-textarea>
                  </template>
                  <span class="wrap-text">{{getItemName('サンプルメモ')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
            </v-row>

<!--
            <v-row dense class="ml-6 mt-2 mb-2">
              <v-col cols="12" lg="12" md="12" dense>
              <span class="caption">{{getItemName('分析目的')[AnalizeTypeCategory+'label']}}</span>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                  <v-textarea
                      v-on="on"
                      v-model="AnalizePurpose"
                      filled
                      counter=256
                    >
                      <template v-slot:prepend-inner v-if="getItemName('分析目的')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                  </v-textarea>
                  </template>
                  <span class="wrap-text">{{getItemName('分析目的')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
            </v-row>
-->
          <v-row align="center" justify="center" dense>
            <v-col cols="10" lg="10" md="10" densa class="px-md-6 pa-2">
              <v-card v-if="isHazardousMaterials==1" flat outlined class="ma-5 pa-3">
                <div class="mb-2">
                  <v-icon class="mr-1" color="red" x-large>mdi-information</v-icon>
                  <span class="display red--text vertical-align-middle">危険物が含まれる分析サンプルのご依頼には事前確認が必要です。</span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span>危険物が含まれるオイルの分析には、必要資料のご提出など事前にご確認頂いただきたい項目がございます。<br></span>
                  <span>お手数おかけしますが、分析・診断サービスの利用について担当営業か、以下よりお問合せ／ご確認をお願いいたします。</span>
                </div>
                <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="openInquiry()" class="mx-2 mb-5">
                  <v-icon class="mr-2">mdi-comment-question-outline  </v-icon>ご連絡・お問合わせ
                </v-btn>
                <div class="subtitle-2 mb-2">
                  <v-icon class="mr-1">mdi-information-outline</v-icon>
                  <span>注意事項などご確認頂きましたのち、下記をチェックして分析サンプルを登録してください。<br></span>
                  <span class="red--text">下記のチェックがされていない分析サンプルは、分析・診断サービスの依頼をすることができません。</span>
                </div>
                <v-card flat class="pa-3">
                  <v-checkbox
                    v-model="HazardousMaterialsConfirmed"
                    class="agree-text" 
                    label="危険物を含む分析サンプルについて、ジャパン・アナリストに確認しました。"
                  ></v-checkbox>
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="TrackingNumber"
                        label="お問い合わせ番号"
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <span>危険物に関するお問合せの番号を入力します</span>
                  </v-tooltip>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
          </v-card-text>
        </v-card>

<!--
            align="center"
          justify="center"
-->
        <v-row
          class="mb-10"
        >
          <v-col cols="6">
            <v-spacer></v-spacer>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    rounded
                    color="amber"
                    @click="confirmCreateSample"
                    data-addSampleTemp
                    class="mx-2">
                      <v-icon>mdi-checkbox-marked-circle</v-icon>分析サンプルを{{ samplingmode }}
                  </v-btn>
                </template>
                <span>分析・診断サービスで依頼するサンプル情報を{{ samplingmode }}します。</span>
              </v-tooltip>
            <v-spacer></v-spacer>
          </v-col>

          <v-col cols="6" class="text-lg-right" v-if ="!isCreate">
            <v-tooltip top color="grey"   >
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" slot="activator" rounded color="red white--text" @click="showDialog()" dark data-delMachine>
                <v-icon class="mr-2">mdi-delete-circle</v-icon>
                この分析サンプルを削除
                </v-btn>
              </template>
              <span>この分析サンプルを削除します</span>
            </v-tooltip>

          </v-col>


        </v-row>
      </v-card>
    </v-form>

    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="90%"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline" id="card-title">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
          登録内容をご確認ください
        </v-card-title>
        <v-card-text>
          下記の登録内容をご確認のうえ、「分析サンプルを{{ samplingmode }}する」ボタンをクリックしてください

          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              サンプル情報
            </v-card-title>
            <v-card-text>
              <v-row dense class="pa-2">

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル名')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SampleName}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('採取日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('採取日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    <template v-if="SamplingAt">{{SamplingAt}}</template>
                    <template v-else>-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('ボトル数')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('ボトル数')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{BottleCount}} 本
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの状態')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの状態')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilConditionText}}
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '航空機'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('採取者')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('採取者')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      <template v-if="SamplingBy">{{SamplingBy}}</template>
                      <template v-else>-</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('サンプル採取場所')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      <template v-if="SamplingPlace">{{SamplingPlace}}</template>
                      <template v-else>-</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('オイル交換有無')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('オイル交換有無')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      <template v-if="isOilChange">EXCHANGE</template>
                      <template v-else>NON</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプルメモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプルメモ')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    <template v-if="SampleMemo">{{SampleMemo}}</template>
                    <template v-else>-</template>
                  </div>
                </v-col>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析目的')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析目的')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    <template v-if="AnalizePurpose">{{AnalizePurpose}}</template>
                    <template v-else>-</template>
                  </div>
                </v-col>
-->
                <template v-if="isHazardousMaterials==1">
                <v-col cols="12" md="12" dense class="mt-2 mb-0 pa-0">
                  <v-checkbox
                    v-model="HazardousMaterialsConfirmed"
                    dense
                    readonly
                    class="agree-text mt-0 mb-0 pa-0" 
                    label="危険物を含む分析サンプルについて、ジャパン・アナリストに確認しました。"
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('お問い合わせ番号')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('お問い合わせ番号')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{TrackingNumber}} 
                  </div>
                </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('必要オイル量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('必要オイル量')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{Require.toLocaleString()}} mL
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析料金')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析料金')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{analizeFee.toLocaleString()}} 円
                  </div>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>

          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              分析・診断内容
            </v-card-title>

            <v-card-text>
              <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析方法')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析方法')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeTypeGroup}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析区分')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析区分')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeTypeName}}
                  </div>
                </v-col>

                <!-- <v-col cols="3"  lg="3" md='3' sm='6' xs="6">
                  <v-text-field v-model="StandardValueName" label="分析規格" dense readonly></v-text-field>
                </v-col> -->

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeSetName}}
                    <template v-if="!AnalizeSetName">-</template>
                  </div>
                </v-col>
<!--
                <v-col cols="12" v-show="isSelectAnalizeSet">
                  <v-select
                    v-model="analizeSetItems"
                    :items="analizeSetItems"
                    item-value="Value"
                    item-text="Text"
                    label="セットに含まれる分析項目"
                    multiple
                    disabled
                    append-icon=""
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip>
                        <span>{{ item.Text }}</span>
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
-->
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析項目')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析項目')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pt-0">
                  <template v-for="(item, index) in analizeSetItems">
                    <v-chip small color="gray" class="white--black ml-2 mb-1" :key="index"> {{item.Text}}</v-chip>
                  </template>
                </v-col>
                
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('個別分析項目')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('個別分析項目')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pt-0">
                  <template v-for="(item, index) in analizeItemNames">
                    <v-chip small color="green" class="white--text ml-2 mb-1" :key="index"> {{item}}</v-chip>
                  </template>
                </v-col>



                <v-col cols="1" lg="2" md="3" sm='12' xs="12" v-show="standardValueList.length">
                  <span class="caption">報告書へ規格の記載：</span>
                  <span v-if="isSwStandard">記載する</span>
                  <span v-if="!isSwStandard">記載しない</span>
                </v-col>
                <v-col cols="12" lg="10" md="9" sm='12' xs="12" v-show="standardValueList.length">
                  <v-text-field v-if="isSwStandard" v-model="StandardValueName" label="記載する分析規格" dense readonly></v-text-field>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('フィルター返却')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('フィルター返却')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{getFilterText(Filter)}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル返却')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル返却')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{getSurplusText(Surplus)}}
                  </div>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>


          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              機器／オイル情報
            </v-card-title>

            <v-card-text>
              <template v-if="AnalizeTypeCategory == '航空機'">
                <template v-if="mountedMachine">
                  <v-row dense class="pa-2">
                    <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="subtitle-2 grey lighten-3 pl-2">
                        {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="subtitle-2 grey lighten-3 pl-2">
                        {{getItemName('マイ機器名_機体')[AnalizeTypeCategory + 'message']}}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="body-1  font-weight-bold pl-2">
                        {{mountedMachine.Name}}
                        <template v-if="!mountedMachine.Name">-</template>
                      </div>
                    </v-col>
  <!--
                    <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="subtitle-2 grey lighten-3 pl-2">
                        {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'label']}}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="subtitle-2 grey lighten-3 pl-2">
                        {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory + 'message']}}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="body-1  font-weight-bold pl-2">
                        {{mountedMachine.CustomerMachineID}}
                        <template v-if="!mountedMachine.CustomerMachineID">-</template>
                      </div>
                    </v-col>
  -->
                    <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="subtitle-2 grey lighten-3 pl-2">
                        {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="subtitle-2 grey lighten-3 pl-2">
                        {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory + 'message']}}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="body-1  font-weight-bold pl-2">
                        {{mountedMachine.TotalOperatingTime}} {{mountedMachine.TotalOperatingTimeUnitText}}
                        <template v-if="!mountedMachine.TotalOperatingTime">-</template>
                      </div>
                    </v-col>

                    <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="subtitle-2 grey lighten-3 pl-2">
                        {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="subtitle-2 grey lighten-3 pl-2">
                        {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory + 'message']}}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                      <div class="body-1  font-weight-bold pl-2">
                        {{mountedMachine.SinceOverhaulTime}} {{mountedMachine.SinceOverhaulTimeUnitText}}
                        <template v-if="!mountedMachine.SinceOverhaulTime">-</template>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </template>

              <v-row dense class="pa-2">
                <template v-if="AnalizeTypeCategory == '一般'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{Name}}
                      <template v-if="!Name">-</template>
                    </div>
                  </v-col>
                </template>

                <template v-if="AnalizeTypeCategory == '航空機' && !mountedMachine">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名_機体')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{Name}}
                      <template v-if="!Name">-</template>
                    </div>
                  </v-col>
                </template>


                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{CustomerMachineID}}
                    <template v-if="!CustomerMachineID">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機械名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機械名')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{Equipment}}
                    <template v-if="!Equipment">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '一般'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('顧客名')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('顧客名')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{CustomerName}}
                      <template v-if="!CustomerName">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MakerText}}
                    <template v-if="!MakerText">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{ModelNumber}}
                    <template v-if="!ModelNumber">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{PurchasedDate}}
                    <template v-if="!PurchasedDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{TotalOperatingTime}} {{TotalOperatingTimeUnitText}}
                    <template v-if="!TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '航空機'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0" >
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理日')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理日')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{OverhaulDate}}
                      <template v-if="!OverhaulDate">-</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{SinceOverhaulTime}} {{SinceOverhaulTimeUnitText}}
                      <template v-if="!SinceOverhaulTime">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MachineMemo}}
                    <template v-if="!MachineMemo">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('システム油量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('システム油量')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SystemOil}} {{SystemOilUnitText}}
                    <template v-if="!SystemOil">-</template>
                  </div>
                </v-col>
              </v-row>

              <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilTypeCategoryText}}／{{OilTypeText}} {{OilPropertyText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilmakerText}}／{{OilModelNumber}} {{OilGradeText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChangeDate}}
                    <template v-if="!OilChangeDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    <template v-if="!OilChange">-</template>
                    <template v-else>
                      {{OilChange}} {{OilChangeUnitText}}
                    </template>
                    <template v-if="!isOilChange">（報告書に印字しない）</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilUsageTime}} {{OilUsageTimeUnitText}}
                    <template v-if="!OilUsageTime">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '航空機'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      <template v-if="UseFilter == undefined">使用していない</template>
                      <template v-else-if="!UseFilter">使用していない</template>
                      <template v-else-if="UseFilter">使用している</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用時間')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用時間')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{FilterUsageTime}} {{FilterUsageTimeUnitText}}
                      <template v-if="!FilterUsageTime">-</template>
                    </div>
                  </v-col>
                </template>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル採取場所')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SamplingPlace}}
                    <template v-if="!SamplingPlace">-</template>
                  </div>
                </v-col>
-->
              </v-row>
            </v-card-text>
          </v-card>



    </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="grey darken-4"
                outlined
                rounded
                elevation="2"
                @click="closeConfirmCreateSample"
              >
              キャンセル
              </v-btn>
            </template>
            <span>サンプル情報を修正します</span>
          </v-tooltip>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              rounded 
              color="amber darken-1" 
              :disabled="processing"
              @click="createSample()" 
              data-createApplication 
              class="px-2"
              >
                <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                <span class="d-none d-sm-flex">分析サンプルを</span>{{ samplingmode }}
              </v-btn> 
            </template>
            <span>サンプル情報を{{ samplingmode }}します</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialogコール -->
  <app-dialog :failureUrl="failureUrl" ref="isFailured"></app-dialog>
  <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>
  <vali-dialog :valiErrorText="valiErrorText" ref="isErrored"></vali-dialog>
  <deleteSampleConfirm class="pa-0" :sampleid="sampleid" :Name="Name" ref="deletedialog"></deleteSampleConfirm>
  <samplingSuccessed :successText="successText" :successUrl="successUrl" :category="AnalizeTypeCategory" ref="isSamplingSuccessed"></samplingSuccessed>

<!--
  <deleteSampleConfirm class="pa-0" :sampleid="item.id" :Name="item.Name" ref="deletedialog"></deleteSampleConfirm>
-->
  </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { createSample } from "../graphql/mutations"
import { updateSample } from "../graphql/mutations"
import { numeric, required, maxLength } from 'vuelidate/lib/validators'
import validations from '../utils/validations.js'
import { getMachine } from '../graphql/queries'
import { getSample } from '../graphql/queries'
import isFailured from "../components/failureDialog.vue"
import valiErrored from "../components/validateErrorDialog.vue"
import entSuccessed from "../components/successDialog.vue"
import samplingSuccessed from "../components/successSamplingDialog.vue"
import generateUuid  from '../utils/generateUuid.js'
import deleteSampleConfirm from '../components/DeleteSampleConfirm'
import utilsMixin  from '../utils/mixin.js'
import utils  from '../utils/utils.js'
//import informationList from '../components/Information'

function isStandardValue (value, vm) {
  if (vm.isSwStandard) {
    if (value) {
      return true
    } else {
      return false
    }
  } else {
    return true
  }
}

function isAnalizeSet (value, vm) {
  console.log('value', value)
  if (!vm.AnalizeSet&&!vm.AnalizeItems.length) {
    return false
  } else {
    return true
  }
}
function alphaNumPlus(value) {
  if(value) {
    // 半角英数（＋ハイフン、ドット、アンダースコア）のみ許可
    if(!value.match(/^[0-9a-zA-Z/.\s_-]*$/)){
        return false;
    }
  }
  return true
}

function float(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1,2})?$/)){
        return false;
    }
  }
  return true
}

function useTime(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1})?$/)){
      if(_value.match(/^([0-9]\d*):([0-5][0-9])$/)){
        return true;
      }else {
        return false;
      }
    }
  }
  return true
}

function analizeItemRelations() {
/*
// 追加項目は必須でないためエラーなし
  console.log("analizeItemRelations:", this.$v.AnalizeItems)
  this.AnalizeItemSubError = {}
  for (var parentItem of Object.keys(this.AnalizeItemSub)) {
    if(this.AnalizeItemSub[parentItem].length==0) {
      this.AnalizeItemSubError[parentItem] = "追加する分析項目を選択してください"
      return false
    }
  }
*/
  return true
}

// (社)汚染度(計数法・SAE)Table1(PCSAE1) 関連チェック1
// (社)汚染度(計数法・SAE)Table2(PCSAE2) 関連チェック1
function analizeItemRelationPCSA1(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PCSA1M")) {
    return vm.AnalizeItems.includes("PCISOM") || vm.analizeSetItems.some(item => item.Value == "PCISOM")
  }

  if(vm.AnalizeItems.includes("PCSA2M")) {
    return vm.AnalizeItems.includes("PCISOM") || vm.analizeSetItems.some(item => item.Value == "PCISOM")
  }

  return true
}

// (社)汚染度(計数法・SAE)Table1(PCSAE1) 関連チェック2
// (社)汚染度(計数法・SAE)Table2(PCSAE2) 関連チェック2
function analizeItemRelationPCSA2(value, vm) {
  let condition1 = 0
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }

  condition1 += vm.AnalizeItems.includes("PCSA1M") ? 1 : 0
  condition1 += vm.AnalizeItems.includes("PCSA2M") ? 1 : 0
  if(condition1 >= 2) {
    return false
  }

  return true
}

// 粘度指数(VI__J) 関連チェック
function analizeItemRelationVI___J(value, vm) {
  console.log("analizeItemRelationVI___J:", vm.AnalizeItems)
  if(vm.AnalizeItems.includes("VI___J")) {
    let condition1 = 0
    condition1 += vm.AnalizeItems.includes("V40__J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V100_J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "V40__J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V100_J").length > 0 ? 1 : 0

    if(condition1 >= 2) {
      return true
    }
    return false
  }
  return true
}

// ｾﾀﾝ指数(CETINJ) 関連チェック
function analizeItemRelationCETINJ(value, vm) {
  console.log("analizeItemRelationCETINJ:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("CETINJ")) {
    let condition1 = 0
    condition1 += vm.AnalizeItems.includes("DIST_M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "DIST_M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0

    if(condition1 >= 2) {
      return true
    }
    return false
  }
  return true
}

// 総発熱量（計算値）(GCVC_J) 関連チェック
function analizeItemRelationGCVC_J(value, vm) {
  console.log("analizeItemRelationGCVC_J:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("GCVC_J")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("KF2__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4___M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("ASH__M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "KF2__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4___M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "ASH__M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    if(condition1 >= 3) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

// 真発熱量（計算値）(NCVC_J)関連チェック
function analizeItemRelationNCVC_J(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("NCVC_J")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("KF2__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4___M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("ASH__M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "KF2__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4___M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "ASH__M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    if(condition1 >= 3) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

// 顕微鏡写真(PHO__X)関連チェック
function analizeItemRelationPHO__X(value, vm) {
  console.log("analizeItemRelationPHO__X:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PHO__X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW01_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW10_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW45_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW80_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW12_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW50_X") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW01_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW10_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW45_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW12_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW50_X").length > 0 ? 1 : 0
    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 写真２枚(PHO2_X)関連チェック
function analizeItemRelationPHO2_X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PHO2_X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW01_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW10_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW45_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW80_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW12_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW50_X") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW01_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW10_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW45_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW12_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW50_X").length > 0 ? 1 : 0
    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 酸溶解・金属元素(SOAP6X)関連チェック
function analizeItemRelationSOAP6X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("SOAP6X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0

    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 灰化・酸溶解・金属分析(SOAP5X)関連チェック
function analizeItemRelationSOAP5X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("SOAP5X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0

    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 環分析n-d-M法(RA___Z) 関連チェック
function analizeItemRelationRA___Z(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("RA___Z")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("RID__J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V100_J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V40__J") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "RID__J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V100_J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V40__J").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    if(condition1 >= 4) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}


export default {

    beforeRouteLeave (to, from, next) {
      // console.log('router',to)
      if (this.$v.$anyDirty&&!this.isPageMove) {
        let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
        if (answer) {
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    },

  mixins:[validations, utilsMixin, generateUuid, utils],
  components:{
    sucDialog: entSuccessed,
    appDialog: isFailured,
    valiDialog: valiErrored,
    deleteSampleConfirm,
    samplingSuccessed,
//    informationList,
  },
  head: {
    title: { inner: '分析サンプル採油'},
  },
  data: () => ({
    Name: "",
    Type: "",
    SampleName: "",
    CustomerName: "",
    CustomerMachineID: "",
    MakerID: "",
    MakerText: "",
    ModelNumber: "",
    PurchasedDate: "",
    SystemOil: 0,
    SystemOilUnit: "",
    SystemOilUnitText: "",
    MachineMemo: "",
    Equipment: "",

    SamplingBy: "",
    SamplingPlace: "",
    AnalizePurpose: "",
    OperatingTime: 0,
    OperatingTimeUnit: "",
    OperatingTimeUnitText: "",

    TotalOperatingTime: 0,
    TotalOperatingTimeUnit: "",
    TotalOperatingTimeUnitText: "",

    OverhaulDate: "",
    SinceOverhaulTime: null,
    SinceOverhaulTimeUnit: "",
    SinceOverhaulTimeUnitText: "",

    OilmakerID: "",
    OilmakerText:"",
    OilModelNumber: "",
    OilGrade: "",
    OilGradeText: "",

    isHazardousMaterials: "0",
    HazardousMaterialsDetail: "",
    HazardousMaterialsConfirmed: "",
    TrackingNumber: "",

    MountPosition: "",

    OilCondition: "02000000",
    OilConditionText: "使用油",
    OilConditionList: [
      {Text: "新油", Value:"01000000"},
      {Text: "使用油", Value:"02000000"},
    ],

    isOilChange: false,
    OilChangeDate: "",
    OilChange: 0,
    OilChangeUnit: "",
    OilChangeUnitText: "",

    OilUsageTime: 0,
    OilUsageTimeUnit: "",
    OilUsageTimeUnitText: "",

    UseFilter: false,
    FilterUsageTime: null,
    FilterUsageTimeUnit: "",
    FilterUsageTimeUnitText: "",

    AnalizeTypeCategory: "",
    AnalizeType: "",
    AnalizeTypeName: "",
    AnalizeTypeGroup: "",
    beforeAnalizeType: "",
    beforeAnalizeTypeName: "",
    beforeAnalizeTypeGroup: "",

    AnalizeSet: "",
    AnalizeSetName: "",

    AnalizeItems: [],

    AnalizeItemSub: {},
    AnalizeItemSubError: {},

    StandardValue: "0",
    StandardValueName: "",
    StandardValueNoName: "分析規格が未選択です",
    Surplus: "0",
    Filter: "001",
    OfficeID: "",
    LatestOrderAt:"",
    LatestOrderNumber: "",

    OilTypeList:[],
    OilTypeCategory:"",
    OilTypeCategoryText:"",
    OilType: "",
    OilTypeText: "",

    OilPropertyList:[
      {Value:"000", Text:"水溶性"},{Value:"000100", Text:"油性"},
    ],
    OilProperty:"",
    OilPropertyText:"",

    Ratio: 0,
    Rounding: 0,

    Price: 0,
    Fee: 0,
    SetPrice: 0,

    SetRequire: 0,
    Require: 0,

    FilterFee: 0,
    PriceString: "",

    Status: "00000000",

    SampleMemo: "",
    SamplingAt: "",
    BottleCount: 1,

    success: false,
    show1: false,
    isConfirmed: false,
    menu2: false,
    // isSuccessed: false,
    isFailured: false,
    // isErrored: false,   
    isSelectAnalizeSet: false,  
    overlayStepper1: true,   
    isSwStandard: false,
    isPageMove: false,
    processing: false,
    successUrl: '/',
    successText: '',
    valiErrorText: '申請内容に不備がございます<br>赤字のエラー箇所を修正ください</p>',
    failureUrl: '/mymachine',
    machineid: "",
    sampleid: "",
    isCreate: false,

    isErrorParam: false,
    ErrorInfo: "",

    analizeTypeGroupList: [],
    oilTypeCategoryList: [],

    analizeTypeList: [],
    analizeItemList: [],  // 該当分析区分の分析項目リスト
    analizeItemSubList: [],  // 該当分析区分の分析項目（サブ）リスト
    activeAnalizeItemList: [],  // 選択中のセットに含まれる項目を除いた分析リスト（依頼できる分析項目リスト）

    analizeSetItems: [], // セットに含まれる分析項目リスト
    analizeItemNames: [], // 選択中の個別分析項目の名称リスト

    analizeSetList: [],
    standardValueList: [],

    mountedMachine: null,

//    inquiry_url: process.env.VUE_APP_INQUIRY_URL,
    inquiry_url: "https://www.japan-analysts.com/contact/",
  }),
  validations() {
    let _validations = {
      SampleName: { required, maxLength: maxLength(50) },
      OperatingTime: { useTime },
      OilChange: { float },
      BottleCount: { numeric, required },
      SampleMemo: { maxLength: maxLength(60) },
      StandardValue: { isStandardValue },
      AnalizeSet: { isAnalizeSet },
      AnalizeItems: { isAnalizeSet, analizeItemRelations, analizeItemRelationPCSA1, analizeItemRelationPCSA2, analizeItemRelationVI___J, analizeItemRelationGCVC_J, analizeItemRelationNCVC_J, analizeItemRelationCETINJ, analizeItemRelationPHO__X, analizeItemRelationPHO2_X,analizeItemRelationSOAP6X,analizeItemRelationSOAP5X,analizeItemRelationRA___Z },
      AnalizeItemSub: {analizeItemRelations},
    }
    if (this.AnalizeTypeCategory == '一般') {
      _validations["SampleName"] = { required, maxLength: maxLength(20) }
      _validations["SamplingBy"] = { maxLength: maxLength(20) }
      _validations["SamplingPlace"] = { maxLength: maxLength(20) }
      _validations["SamplingAt"] = { required }
    }else {
      _validations["SampleName"] = { required, alphaNumPlus, maxLength: maxLength(15) }
      _validations["SamplingBy"] = { alphaNumPlus, maxLength: maxLength(12) }
      _validations["SamplingPlace"] = { alphaNumPlus, maxLength: maxLength(12) }
      _validations["SamplingAt"] = { required }
    }
    return _validations
  },
  computed: {
    SampleNameErrors () {
        return this.defaultMessage(this.$v.SampleName)
    },
    SamplingAtErrors () {
        return this.defaultMessage(this.$v.SamplingAt)
    },
    SamplingByErrors () {
        return this.defaultMessage(this.$v.SamplingBy)
    },
    SamplingPlaceErrors () {
        return this.defaultMessage(this.$v.SamplingPlace)
    },
    BottleCountErrors () {
        return this.defaultMessage(this.$v.BottleCount)
    },
    SampleMemoErrors () {
        return this.defaultMessage(this.$v.SampleMemo)
    },
    AnalizeSetErrors () {
        return this.defaultMessage(this.$v.AnalizeSet)
    },
    AnalizeItemsErrors () {
      return this.defaultMessage(this.$v.AnalizeItems)
    },
    StandardValueErrors () {
        return this.defaultMessage(this.$v.StandardValue)
    },

    useUnits () {
      return this.$store.state.useUnits
    },
    liquidUnits () {
      return this.$store.state.liquidUnits
    },
    analizeFee() {
      return this.Fee + this.FilterFee
    },
    samplingmode() {
      if(this.isCreate) return "登録"
      else return "更新"
    }
  },
  methods: {
      confirmCreateSample: async function() {
/*
        if(!this.mountedMachine) {
          this.mountedMachine = {
            Name:"",
            CustomerMachineID: "",
            MakerText: "",
            ModelNumber: "",
            PurchasedDate: "",
            TotalOperatingTime: "",
            OverhaulDate: "",
            SinceOverhaulTime: "",
            MachineMemo: "",
            isDummy: true,
          }
        }
*/
        this.isConfirmed=true
      },
      closeConfirmCreateSample: async function() {
/*
        if(this.mountedMachine.isDummy) {
          this.mountedMachine = null
        }
*/
        this.isConfirmed=false
      },
      createSample: async function () {
        this.isConfirmed = false
        this.processing = true
        this.$v.$touch()
        console.log("createSample:", this.$v)
        if (this.$v.$invalid) {
          console.log('error: ', 'validation error')
          // this.isErrored = true
          this.$refs.isErrored.open();          
          this.e6 = 1
          this.processing = false
          return
        } 

        let _HazardousMaterialsConfirmed = ""
        // 危険物あり且つ確認済みチェック未の場合は一時保存
        // それ以外（危険物がないか、危険物あり且つ確認済みチェック済みは完了
        if((this.isHazardousMaterials == "1") && (this.HazardousMaterialsConfirmed != true)) {
          this.Status = "00000000"
          _HazardousMaterialsConfirmed = "0"
        }else if((this.isHazardousMaterials == "1") && (this.HazardousMaterialsConfirmed == true)) {
          this.Status = "10000000"
          _HazardousMaterialsConfirmed = "1"
        }else {
          this.Status = "10000000"
          _HazardousMaterialsConfirmed = ""
        }
        console.log("isHazardousMaterials:", this.isHazardousMaterials)
        console.log("HazardousMaterialsConfirmed:", this.HazardousMaterialsConfirmed)
        console.log("Status:", this.Status)

        // 機体情報があれば設定なければからのJSON（機体情報はすべて空欄）
        let mountedMachine = {}
        let AircraftName = ""
        if(this.mountedMachine != null) {
          mountedMachine = this.mountedMachine
          AircraftName = mountedMachine.Name //注：機体番号はマイ機器名（Name）に入っている（機体はマイ機器IDはなし）
        }else {
          if(this.AnalizeTypeCategory == '航空機') {
            // 機体に紐づいていない場合、マイ機器のマイ機器名に機体名が入る
            AircraftName = this.Name
          }
        }

        let _isOilChange = ""
        let _OilChange = ""
        let _OilChangeUnit = ""
        let _OilChangeUnitText = ""
        if(this.AnalizeTypeCategory == '一般') {
          this.isOilChange = true
        }
        if(this.isOilChange) {
          _isOilChange = "Y"
          _OilChange = this.OilChange
          _OilChangeUnit = this.OilChangeUnit
          _OilChangeUnitText = this.OilChangeUnitText
        }else {
          _isOilChange = "N"
        }

        //サンプリング直後（まだ依頼に出していない）データのOfficeIDは、OfficeID + "-00000000"で設定
        //依頼されたときに、正しいOfficeIDに更新する。
        const sample = {
//        id: uuid,
          SamplingAt: this.SamplingAt,
//        SamplerName: "",
          MachineID: this.machineid,
          Name: this.SampleName,
          AnalizeTypeGroup: this.AnalizeTypeGroup,
          AnalizeTypeGroupName: this.AnalizeTypeGroup,
          CustomerName: this.CustomerName,
          CustomerMachineID: this.CustomerMachineID,
//        MachineCategory: "",          
//        MachineCategoryText: "",          
//        MachineType: "",          
//        MachineTypeText: "",          
          Equipment: this.Equipment,
          MakerID: this.MakerID,
          MakerText: this.MakerText,
          ModelNumber: this.ModelNumber,
          PurchasedDate: this.PurchasedDate,
          SystemOil: this.SystemOil,
          SystemOilUnit: this.SystemOilUnit,
          SystemOilUnitText: this.SystemOilUnitText,
          MachineMemo: this.MachineMemo,
          TotalOperatingTime: this.TotalOperatingTime,
          TotalOperatingTimeUnit: this.TotalOperatingTimeUnit,
          TotalOperatingTimeUnitText: this.TotalOperatingTimeUnitText,
          OperatingTime: this.OperatingTime,
          OperatingTimeUnit: this.OperatingTimeUnit,
          OperatingTimeUnitText: this.OperatingTimeUnitText,
          OverhaulDate: this.OverhaulDate,
          SinceOverhaulTime: this.SinceOverhaulTime,
          SinceOverhaulTimeUnit: this.SinceOverhaulTimeUnit,
          SinceOverhaulTimeUnitText: this.SinceOverhaulTimeUnitText,
//          ParentCustomerMachineID: mountedMachine.CustomerMachineID,
//          ParentCustomerMachineID: mountedMachine.Name, //注：機体番号はマイ機器名（Name）に入っている（機体はマイ機器IDはなし）
          ParentCustomerMachineID: AircraftName, // 機体に紐づいている場合は機体のName。機体に紐づいていない場合は装備品のName
          ParentEquipment: mountedMachine.Equipment,
          ParentMakerID: mountedMachine.MakerID,
          ParentMakerText: mountedMachine.MakerText,
          ParentModelNumber: mountedMachine.ModelNumber,
          ParentPurchasedDate: mountedMachine.PurchasedDate,
          ParentTotalOperatingTime: mountedMachine.TotalOperatingTime,
          ParentTotalOperatingTimeUnit: mountedMachine.TotalOperatingTimeUnit,
          ParentTotalOperatingTimeUnitText: mountedMachine.TotalOperatingTimeUnitText,
          ParentSinceOverhaulTime: mountedMachine.SinceOverhaulTime,
          ParentSinceOverhaulTimeUnit: mountedMachine.SinceOverhaulTimeUnit,
          ParentSinceOverhaulTimeUnitText: mountedMachine.SinceOverhaulTimeUnitText,
          OilmakerID: this.OilmakerID,
          OilmakerText: this.OilmakerText,
          OilModelNumber: this.OilModelNumber,
//        OilGrade: this.OilGrade,
//        OilGradeText: this.OilGradeText
          OilTypeCategory: this.OilTypeCategory,
          OilTypeCategoryText: this.OilTypeCategoryText,
          OilType: this.OilType,
          OilTypeText: this.OilTypeText,
          OilProperty: this.OilProperty,
          OilPropertyText: this.OilPropertyText,
          isHazardousMaterials: this.isHazardousMaterials,
          HazardousMaterialsDetail: this.HazardousMaterialsDetail,
          HazardousMaterialsConfirmed: _HazardousMaterialsConfirmed,
          TrackingNumber: this.TrackingNumber,
          OilChangeDate: this.OilChangeDate,
          isOilChange: _isOilChange,
          OilChange: _OilChange,
          OilChangeUnit: _OilChangeUnit,
          OilChangeUnitText: _OilChangeUnitText,
          OilUsageTime: this.OilUsageTime,
          OilUsageTimeUnit: this.OilUsageTimeUnit,
          OilUsageTimeUnitText: this.OilUsageTimeUnitText,
          UseFilter: this.UseFilter,
          FilterUsageTime: this.FilterUsageTime,
          FilterUsageTimeUnit: this.FilterUsageTimeUnit,
          FilterUsageTimeUnitText: this.FilterUsageTimeUnitText,
          OilCondition: this.OilCondition,
          OilConditionText: this.OilConditionText,
          AnalizeType: this.AnalizeType,
          AnalizeTypeName: this.AnalizeTypeName,
          AnalizeSet: this.AnalizeSet,
          AnalizeSetName: this.AnalizeSetName,
          AnalizeItems: JSON.stringify(this.AnalizeItems),
//        AnalizeItemNames: this.AnalizeItemNames,          
          AnalizeItemSub: JSON.stringify(this.AnalizeItemSub),
          AnalizePurpose: this.AnalizePurpose,
          StandardValue: this.StandardValue,
          StandardValueName: this.StandardValueName,
          Surplus: this.Surplus,
          Filter: this.Filter,
          LatestOrderNumber: this.LatestOrderNumber,
          OfficeID: this.$store.state.operatingOffice.OfficeID + "-00000000",
          BottleCount: this.BottleCount,
          ApplicationID: "00000000",
          Status: this.Status,
          Memo: this.SampleMemo,
          SamplingBy: this.SamplingBy,
          SamplingPlace: this.SamplingPlace,
          MountPosition: this.MountPosition,
//        DeliveryPeriod: "",
          Quantity: this.Require,
          Price: this.Price + this.FilterFee,
//        Report: "",
//        Opinion: "",
          Fee: this.Fee + this.FilterFee,
        }

        if(this.isCreate) {
          //Sample.idの値を自己生成 形式は4×4
//        let uuid = ""
//          uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
          sample["id"] = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
          try {
            console.log('sample', sample)
            await API.graphql(graphqlOperation(createSample, {input: sample}))
            console.log('success', sample)
            // this.isSuccessed = true
            window.removeEventListener("beforeunload", this.handler)
            this.isPageMove=true
            this.successText = '分析サンプル情報を登録しました。<br><br>お申込みページの「登録済み分析サンプル」でご確認いただけます。',
            this.$refs.isSamplingSuccessed.open();
          } catch (error) {
            console.log('error: ', error)
            // this.isFailured = true
            this.processing = false
            this.$refs.isFailured.open();
          }
        }else {
          sample["id"] = this.sampleid
          try {
            console.log('sample', sample)
            await API.graphql(graphqlOperation(updateSample, {input: sample}))
            console.log('success', sample)
            // this.isSuccessed = true
            window.removeEventListener("beforeunload", this.handler)
            this.isPageMove=true
            this.successText = '分析サンプル情報を更新しました。<br><br>お申込みページの「登録済み分析サンプル」でご確認いただけます。'
            this.$refs.isSuccessed.open();
          } catch (error) {
            console.log('error: ', error)
            // this.isFailured = true
            this.processing = false
            this.$refs.isFailured.open();
          }
        }
      },
/* 2.4修正前
      changeAnalizeTypeGroup: async function() {
          this.isItemsInclude = false
          console.log('this.AnalizeTypeGroup: ', this.AnalizeTypeGroup)
//          const typelist = this.$store.state.analizeTypeList.filter(item => item.AnalizeTypeGroup  == this.AnalizeTypeGroup)
          const typelist = this.analizeTypeList.filter(item => item.AnalizeTypeGroup  == this.AnalizeTypeGroup)
          console.log('typelist: ', typelist)
          this.analizeTypeList = typelist[0].AnalizeTypes
          this.AnalizeType = ""
          this.AnalizeTypeName = ""
          this.AnalizeSet = ""
          this.AnalizeSetName = ""
          this.AnalizeItems = ""
          this.StandardValue = ""
          this.StandardValueName = ""
      },
*/
      changeAnalizeTypeGroup: async function() {
        console.log("changeAnalizeTypeGroup")
          this.isSelectAnalizeSet = false
          const typeGroup = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
          this.analizeTypeList = await this.getAnalizeTypeList(this.AnalizeTypeGroup)
          this.AnalizeTypeGroupName = typeGroup[0].Text

          if(this.OilTypeCategory){
            this.AnalizeType = String(Number(typeGroup[0].Code) + Number(this.OilTypeCategory))
            this.changeAnalizeType()
          }
      },
      changeAnalizeType: async function () {
          this.isSelectAnalizeSet = false
          this.analizeSetList = await this.getAnalizeSetList(this.AnalizeType)
          this.analizeItemList = await this.getAnalizeItemList(this.AnalizeType)
          this.activeAnalizeItemList = this.analizeItemList
          this.analizeItemSubList = await this.getAnalizeItemSubList(this.AnalizeType)

/* 一旦削除！
          let standardvaluelist = this.$store.state.standardValueList.filter(item => item.AnalizeType  == this.AnalizeType)
          this.standardValueList = standardvaluelist[0].standardValues
*/

          this.AnalizeSet = ""
          this.AnalizeSetName = ""
          this.AnalizeItems = ""
          this.AnalizeItemSub = {}
          this.StandardValue = ""
          this.StandardValueName = ""

          this.Price = 0
          this.Fee = 0
          this.Require = 0
          this.SetPrice = 0
          this.SetRequire = 0

          const AnalizeTypeName = this.analizeTypeList.filter(item => item.Value  == this.AnalizeType)
          this.AnalizeTypeName = AnalizeTypeName[0].Text
      },
      changeAnalizeSet: async function () {
        this.isSelectAnalizeSet = false
        if (this.AnalizeSet) {
          // セットが選びなおされた場合、個別分析項目をリセットする（セットと重複することがあるため）
          this.AnalizeItems = []

          const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
          this.AnalizeSetName = AnalizeSetName[0].Text
          this.analizeSetItems = []
//            this.includeItem()
          this.activeAnalizeItemList = await this.excludeAnalizeItems(AnalizeSetName[0].AnalizeItems, this.analizeItemList)

          this.analizeSetItems = await this.getAnalizeSetItems(AnalizeSetName[0])
          console.log("analizeSetItems", this.analizeSetItems)
          this.isSelectAnalizeSet = true

          this.SetPrice = AnalizeSetName[0].Price
          this.SetRequire = AnalizeSetName[0].Require
          this.Price = this.SetPrice
          this.Fee = this.SetPrice
          this.Require = this.SetRequire
        } else {
          this.activeAnalizeItemList = this.analizeItemList
          this.AnalizeSet = ""
          this.AnalizeSetName = ""
          this.analizeSetItems = []
          this.Price = this.Price - this.SetPrice
          this.Fee = this.Fee - this.SetPrice
          this.Require = this.Require - this.SetRequire
          this.SetPrice = 0
          this.SetRequire = 0
        }
        await this.changeAnalizeItems(this.AnalizeItems)
        // セット分析の選択・解除に伴い、個別分析項目のバリデーションを再評価させる
        // （初期表示直後はまだ未touchのため、セットを✕で消してもチェックが動かない対策）
        this.$v.AnalizeItems.$touch()
      },
      changeStandardValue: async function () {
          const StandardValueName = this.standardValueList.filter(item => item.Value  == this.StandardValue)
          if (StandardValueName[0]) {
            this.StandardValueName = StandardValueName[0].Text
            // console.log('StandardValueName', this.StandardValueName)
          }
          if (!this.StandardValue) { this.StandardValueName = "" }
      },
      changeSwStandard: async function () {
        // console.log('changeSwStandard')
          if (this.isSwStandard == false) {
            this.StandardValue = ""
            this.StandardValueName = ""
          }
      },
      changeAnalizeItems: async function (selecteditems) {
        console.log("changeAnalizeItems:", selecteditems)
//        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.analizeItemList)
        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
        console.log("analizeItemNames:", this.analizeItemNames)

        for (var parentItem of Object.keys(this.analizeItemSubList)) {
          if(selecteditems.includes(parentItem)) {
            // サブ項目がある分析項目がえらばれている場合は配列をセット（継続）
            let selectedSub = this.AnalizeItemSub[parentItem]
            if(selectedSub == undefined) {
              selectedSub = []
            }
//            this.AnalizeItemSub[parentItem] = selectedSub
            this.$set(this.AnalizeItemSub, parentItem, selectedSub);
          }else {
            const includeSet = this.analizeSetItems.filter(item => item.Value  == parentItem)
            if(!includeSet[0]) {
              // サブ項目がある分析項目が選ばれていなかった且つ、セットにも含まれていない場合は削除（リセット）
              delete this.AnalizeItemSub[parentItem]
            }else {
              let selectedSub = this.AnalizeItemSub[parentItem]
              if(selectedSub == undefined) {
                selectedSub = []
              }
              this.$set(this.AnalizeItemSub, parentItem, selectedSub);
            }
          }
        }

        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
        console.log("analizeItemNames:", this.analizeItemNames)

        this.calcAnalizeItemPriceAll()
      },
      changeAnalizeItemSub: async function() {
        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
        console.log("analizeItemNames:", this.analizeItemNames)

        this.calcAnalizeItemPriceAll()

        // 強制的に個別分析項目のvalidationを実行させるために値を一次的に変更
        //値が変わらないとtouchが実行されない=validationsが実行されない        
        this.AnalizeItems.push("dummy")
        this.AnalizeItems.pop("dummy")
        this.$v.AnalizeItems.$touch()
      },

      calcAnalizeItemPriceAll: function() {
        this.Price = this.SetPrice
        this.Fee = this.SetPrice
        this.Require = this.SetRequire

        for (var selecteditem of this.AnalizeItems) {
          let itemlist = this.analizeItemList.filter(item => item.Value  == selecteditem)
          this.calcAnalizeItemPrice(itemlist[0])
          this.Require = this.Require + Number(itemlist[0].Require)
        }

        if(this.AnalizeItemSub) {
          for (var parentItem of Object.keys(this.AnalizeItemSub)) {
              let _analizeItemSubList = this.analizeItemSubList[parentItem]
              for (var selecteditemsub of this.AnalizeItemSub[parentItem]) {
                let itemlist = _analizeItemSubList.filter(item => item.Value  == selecteditemsub)
                this.calcAnalizeItemPrice(itemlist[0])
                this.Require = this.Require + Number(itemlist[0].Require)
              }
            }
        }
      },
      changeOilCondition: async function() {
        const oilCondition = this.OilConditionList.filter(item => item.Value == this.OilCondition)
        this.OilConditionText = oilCondition[0].Text
      },

      calcAnalizeItemPrice: function(item) {
        let price = Number(item.Price)
        let fee = this.getAnalizeItemFee(item,this.Ratio,this.Rounding)
        let discount = price - fee

        this.Price = this.Price + price
        this.Fee = this.Fee + fee
        this.Discount = this.Discount + discount
        this.consolelogPrice()
      },
      changeFilter: async function (selecteditem) {
        this.computeFilterFee(selecteditem)
      },
      computeFilterFee: function(filter) {
        console.log('computeFilterFee', filter)
        switch (filter){
          case "001": // なし
            this.FilterFee = 0;
            break
          case "002": // ラミネート加工 1700円
            this.FilterFee = 1700;
            break
          default: // case 003 ラミネート加工なし 600円
            this.FilterFee = 600;
            break
        }
        console.log('FilterFee', this.FilterFee)
      },
      consolelogPrice() {

        let pricelog = {
          SetPrice: this.SetPrice,
          SetRequire: this.SetRequire,
          Price: this.Price,
          Fee: this.Fee,
          Require: this.Require,
          FilterFee: this.FilterFee,
          Discount: this.Discount,
        }
        console.log("price log", pricelog)

      },
      getAnalizeItemName(analizeItem) {
        let item = this.analizeItemList.filter(item => item.Value  == analizeItem)
        return item[0].Text

      },      
      back: async function () {
        this.$router.back()
      },
      handler (event) {
        event.returnValue = "Data you've inputted won't be synced"
        console.log('ページ離脱')
      },
      showDialog() {
        this.$refs.deletedialog.open();
      },
      openInquiry() {
          window.open(this.inquiry_url, '_blank')
      },
      // clearAnalizeSet() {
      //   // console.log('クリアがクリック', this.AnalizeTypeName, this.AnalizeType)
      //   const itemlist = this.$store.state.analizeItemList.filter(item => item.AnalizeType  == this.AnalizeType)
      //   this.analizeItemList = itemlist[0].AnalizeItems
      // },
      // successDialog() {
      //     this.isSuccessed = false
      //     this.$router.push('/')
      // },
      // failureDialog() {
      //     this.isFailured = false
      //     this.$router.push('/mymachine')
      // },
    initialize: async function() {

    },
  },
  mounted: async function () {
    console.log('mode: ', this.$route.query.mode)
    console.log('id: ', this.$route.query.id)

    this.Ratio = Number(this.$store.state.operatingCompany.Ratio) / 100
    this.Rounding = this.$store.state.operatingCompany.Rounding

    //「mode」が指定されていない場合は新規登録。「id」はマイ機器ID
    //「mode」が指定されている場合は更新。「id」はサンプルID
    //※現時点でmodeは新規作成か更新のみのためif-elseで実装
    let updatesample = {}
    if(!this.$route.query.mode) {
      console.log('create sample: ', this.$route.query.id)
      this.isCreate = true
      this.machineid = this.$route.query.id
    }else {
      console.log('update sample: ', this.$route.query.id)
      this.isCreate = false
      this.sampleid = this.$route.query.id
      updatesample = await API.graphql(graphqlOperation(getSample, {id: this.sampleid}))
      if(!updatesample.data.getSample) {
        this.isErrorParam = true
        this.ErrorInfo = "notExist"
        this.overlayStepper1 = false
        console.log('isErrorParam: ', this.isErrorParam)
        return
      }else {
        this.machineid = updatesample.data.getSample.MachineID
      }
    }

    let machine = await API.graphql(graphqlOperation(getMachine, {id: this.machineid}))
    // 採油するマイ機器情報のアクセスチェック
    // 存在しないマイ機器、他事業所のマイ機器を開いた場合はアクセス不正でエラーにする
    if(!machine.data.getMachine) {
      this.isErrorParam = true
      this.ErrorInfo = "notExist"
      this.overlayStepper1 = false
      console.log('isErrorParam: ', this.isErrorParam)
      return
    }

    // この機器が機体と関連づいている場合は機体情報を取得
    if((machine.data.getMachine.MountedMachineID != undefined) && (machine.data.getMachine.MountedMachineID != "")) {
      let mountedMachine = await API.graphql(graphqlOperation(getMachine, {id: machine.data.getMachine.MountedMachineID}))
      this.mountedMachine = mountedMachine.data.getMachine
    }

    if(machine.data.getMachine.OfficeID != this.$store.state.operatingOffice.OfficeID) {
      this.isErrorParam = true
      this.ErrorInfo = "illegalAccess"
      this.overlayStepper1 = false
      console.log('isErrorParam: ', this.isErrorParam)
      return
    }

    this.AnalizeTypeCategory = await this.getMachineAnalizeTypeCategory(machine.data.getMachine)
    console.log("this.AnalizeTypeCategory:", this.AnalizeTypeCategory)
    this.Type = this.getMachineType(machine.data.getMachine)

    this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)
    console.log("this.analizeTypeGroupList:", this.analizeTypeGroupList)

    this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)
    console.log("this.oilTypeCategoryList:", this.oilTypeCategoryList)

    this.Name = machine.data.getMachine.Name
//    this.SampleName = machine.data.getMachine.Name
    this.CustomerMachineID = machine.data.getMachine.CustomerMachineID
    this.CustomerName = machine.data.getMachine.CustomerName
    this.MakerID = machine.data.getMachine.MakerID
    this.MakerText = machine.data.getMachine.MakerID
    if(machine.data.getMachine.OilmakerText == undefined) {
      this.OilmakerText = machine.data.getMachine.OilmakerID
    }else {
      this.OilmakerText = machine.data.getMachine.OilmakerText
    }

    this.Equipment = machine.data.getMachine.Equipment
    this.ModelNumber = machine.data.getMachine.ModelNumber
    this.PurchasedDate = machine.data.getMachine.PurchasedDate
    this.SystemOil = machine.data.getMachine.SystemOil
    this.SystemOilUnit = machine.data.getMachine.SystemOilUnit
    this.SystemOilUnitText = machine.data.getMachine.SystemOilUnitText
    this.MachineMemo = machine.data.getMachine.MachineMemo
    this.OperatingTime = machine.data.getMachine.OperatingTime
    this.OperatingTimeUnit = machine.data.getMachine.OperatingTimeUnit
    this.OperatingTimeUnitText = machine.data.getMachine.OperatingTimeUnitText
    this.TotalOperatingTime = machine.data.getMachine.TotalOperatingTime
    this.TotalOperatingTimeUnit = machine.data.getMachine.TotalOperatingTimeUnit
    this.TotalOperatingTimeUnitText = machine.data.getMachine.TotalOperatingTimeUnitText

    this.SinceOverhaulTime = machine.data.getMachine.SinceOverhaulTime
    this.SinceOverhaulTimeUnit = machine.data.getMachine.SinceOverhaulTimeUnit
    this.SinceOverhaulTimeUnitText = machine.data.getMachine.SinceOverhaulTimeUnitText

    // console.log('Units', this.units)
    this.OilmakerID = machine.data.getMachine.OilmakerID
    this.OilModelNumber = machine.data.getMachine.OilModelNumber

    let _OilTypeCategory = machine.data.getMachine.OilTypeCategory
    let _OilType = machine.data.getMachine.OilType
    this.OilTypeCategoryText = machine.data.getMachine.OilTypeCategoryText
    this.OilTypeText = machine.data.getMachine.OilTypeText
    this.OilProperty = machine.data.getMachine.OilProperty
    this.OilPropertyText = machine.data.getMachine.OilPropertyText

    this.isHazardousMaterials = machine.data.getMachine.isHazardousMaterials
    this.HazardousMaterialsDetail = machine.data.getMachine.HazardousMaterialsDetail
    this.OilChangeDate = machine.data.getMachine.OilChangeDate
    this.OilChange = machine.data.getMachine.OilChange
    this.OilChangeUnit = machine.data.getMachine.OilChangeUnit
    this.OilUsageTime = machine.data.getMachine.OilUsageTime
    this.OilUsageTimeUnit = machine.data.getMachine.OilUsageTimeUnit
    this.OilUsageTimeUnitText = machine.data.getMachine.OilUsageTimeUnitText

    this.UseFilter = machine.data.getMachine.UseFilter
    this.FilterUsageTime = machine.data.getMachine.FilterUsageTime
    this.FilterUsageTimeUnit = machine.data.getMachine.FilterUsageTimeUnit
    this.FilterUsageTimeUnitText = machine.data.getMachine.FilterUsageTimeUnitText

    this.AnalizeTypeGroup = machine.data.getMachine.AnalizeTypeGroup
    this.AnalizeType = machine.data.getMachine.AnalizeType
    this.beforeAnalizeType = this.AnalizeType
    this.beforeAnalizeTypeGroup = this.AnalizeTypeGroup
    this.AnalizeSet = machine.data.getMachine.AnalizeSet
    //選択中の分析項目の一覧は、分析項目リストを設定した後で入れないと反映されないのでローカル変数に一旦保持
    //※全分析項目のリストから、セット分析の該当項目を後の処理（）でやっているのでこのようにしなければいけない。
//    this.AnalizeItems = JSON.parse(machine.data.getMachine.AnalizeItems)
    let _AnalizeItems = JSON.parse(machine.data.getMachine.AnalizeItems)

    this.AnalizeItemSub = {}
    let _AnalizeItemSub = {}
    if(machine.data.getMachine.AnalizeItemSub != undefined) {
      _AnalizeItemSub = JSON.parse(machine.data.getMachine.AnalizeItemSub)
/*
      for (var parentItem of Object.keys(_AnalizeItemSub)) {
          console.log(parentItem, _AnalizeItemSub[parentItem])
          this.AnalizeItemSub[parentItem] = _AnalizeItemSub[parentItem]
      }
*/
    }

    this.StandardValue = machine.data.getMachine.StandardValue
    this.Surplus = machine.data.getMachine.Surplus
    this.Filter = machine.data.getMachine.Filter
    this.computeFilterFee(this.Filter)
    this.OfficeID = machine.data.getMachine.OfficeID
    if(machine.data.getMachine.LatestOrderAt)
      this.LatestOrderAt = machine.data.getMachine.LatestOrderAt.substring(0,10)
    this.LatestOrderNumber = machine.data.getMachine.LatestOrderNumber

    if(this.AnalizeTypeCategory == "航空機" ) {
      this.SampleName = machine.data.getMachine.CustomerMachineID
      this.SamplingBy = machine.data.getMachine.SamplingBy
    }else {
      this.SampleName = machine.data.getMachine.Name
      this.SamplingBy = this.$store.state.employee.Name
    }

    this.SamplingPlace = machine.data.getMachine.SamplingPlace
    this.AnalizePurpose = machine.data.getMachine.AnalizePurpose
    this.MountPosition = machine.data.getMachine.MountPosition

    //更新コードの場合は、該当サンプル情報を上書きセット
    if(!this.isCreate) {
      this.SamplingAt = updatesample.data.getSample.SamplingAt
      this.SampleName = updatesample.data.getSample.Name
      this.AnalizeTypeGroup = updatesample.data.getSample.AnalizeTypeGroup
      this.AnalizeTypeGroupName = updatesample.data.getSample.AnalizeTypeGroupName
      this.AnalizeType = updatesample.data.getSample.AnalizeType
      this.AnalizeTypeName = updatesample.data.getSample.AnalizeTypeName
      this.AnalizeSet = updatesample.data.getSample.AnalizeSet
      this.AnalizeSetName = updatesample.data.getSample.AnalizeSetName
//      this.AnalizeItems = JSON.parse(updatesample.data.getSample.AnalizeItems)
      _AnalizeItems = JSON.parse(updatesample.data.getSample.AnalizeItems)

      this.AnalizeItemSub = {}
      if(updatesample.data.getSample.AnalizeItemSub != undefined) {
        _AnalizeItemSub = JSON.parse(updatesample.data.getSample.AnalizeItemSub)
      }

      this.StandardValue = updatesample.data.getSample.StandardValue
      this.StandardValueName = updatesample.data.getSample.StandardValueName
      this.Surplus = updatesample.data.getSample.Surplus
      this.Filter = updatesample.data.getSample.Filter
      this.SampleMemo = updatesample.data.getSample.Memo
      this.BottleCount = updatesample.data.getSample.BottleCount
      this.Status = updatesample.data.getSample.Status
      if(updatesample.data.getSample.HazardousMaterialsConfirmed == "1"){
        this.HazardousMaterialsConfirmed = true
      }else {
        this.HazardousMaterialsConfirmed = false
      }
      this.TrackingNumber = updatesample.data.getSample.TrackingNumber

      this.SamplingPlace = updatesample.data.getSample.SamplingPlace
      this.SamplingBy = updatesample.data.getSample.SamplingBy

      this.OilCondition = updatesample.data.getSample.OilCondition
      this.OilConditionText = updatesample.data.getSample.OilConditionText
      this.AnalizePurpose = updatesample.data.getSample.AnalizePurpose
    }

    this.SetPrice = 0
    this.SetRequire = 0
    this.Price = 0
    this.Fee = 0
    this.Require = 0

    await this.changeAnalizeTypeGroup()
    this.analizeTypeList = await this.getAnalizeTypeList(this.AnalizeTypeGroup)
    this.analizeSetList = await this.getAnalizeSetList(this.AnalizeType)
    this.analizeItemList = await this.getAnalizeItemList(this.AnalizeType)
    this.activeAnalizeItemList = this.analizeItemList
    this.analizeItemSubList = await this.getAnalizeItemSubList(this.AnalizeType)

/* 一旦削除！
    let standardvaluelist = this.$store.state.standardValueList.filter(item => item.AnalizeType  == this.AnalizeType)
    this.standardValueList = standardvaluelist[0].standardValues
*/

    const OperatingTimeUnitName = this.useUnits.filter(item => item.Value  == this.OperatingTimeUnit)
    if (OperatingTimeUnitName[0]) {
      this.OperatingTimeUnitText = OperatingTimeUnitName[0].Text
    }
    const OilChangeUnitName = this.liquidUnits.filter(item => item.Value  == this.OilChangeUnit)
    if (OilChangeUnitName[0]) {
      this.OilChangeUnitText = OilChangeUnitName[0].Text
    }
    const AnalizeTypeName = this.analizeTypeList.filter(item => item.Value  == this.AnalizeType)
    if (AnalizeTypeName[0]) {
      this.AnalizeTypeName = AnalizeTypeName[0].Text
      this.beforeAnalizeTypeName = AnalizeTypeName[0].Text
    }
    
    if(this.AnalizeSet) {
      const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
      if(AnalizeSetName[0]) {
        this.AnalizeSetName = AnalizeSetName[0].Text

        this.analizeSetItems = []
        this.activeAnalizeItemList = await this.excludeAnalizeItems(AnalizeSetName[0].AnalizeItems, this.analizeItemList)

        this.analizeSetItems = await this.getAnalizeSetItems(AnalizeSetName[0])
        this.isSelectAnalizeSet = true

        this.SetPrice = AnalizeSetName[0].Price
        this.SetRequire = AnalizeSetName[0].Require
        this.Price = this.SetPrice
        this.Fee = this.SetPrice
        this.Require = this.SetRequire
      }else {
        console.log("anailize set not found", this.AnalizeSet)
      }
    }
    
    for (var AnalizeItem of _AnalizeItems) {
      let itemlist = this.analizeItemList.filter(item => item.Value  == AnalizeItem)
      this.Price = this.Price + Number(itemlist[0].Price)
      this.Fee = this.Fee + this.getAnalizeItemFee(itemlist[0],this.Ratio,this.Rounding)
      this.Require = this.Require + Number(itemlist[0].Require)
    }
    this.AnalizeItems = _AnalizeItems

    this.AnalizeItemSub = _AnalizeItemSub

/*
    this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.analizeItemList)
    console.log("analizeItemNames:", this.analizeItemNames)
*/
    this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
    console.log("analizeItemNames:", this.analizeItemNames)

    const StandardValueName = this.standardValueList.filter(item => item.Value  == this.StandardValue)
    if (StandardValueName[0]) {
      this.StandardValueName = StandardValueName[0].Text
      this.isSwStandard = true 
    }

    this.OilTypeCategory = _OilTypeCategory
/*
    const oilTypes = this.$store.state.oilTypeList.filter(item => item.OilTypeCategory  == this.OilTypeCategory)
    if(oilTypes[0]) {
      this.OilTypeList = oilTypes[0].OilType
      this.OilType = _OilType
    }
*/
    this.OilTypeList = await this.getOilTypeList(this.OilTypeCategory + this.AnalizeTypeCategory)
    this.OilType = _OilType

    this.calcAnalizeItemPriceAll()

    this.overlayStepper1 = false
  },
  created () {
    window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.handler)
  }      
}
</script>
<style scoped>
.agree-text /deep/ label {
    color: black;
}
.label-chip {
  margin-right : 10px;
  width: 150px;
}
.wrap-text {
  overflow-wrap: break-all;
  word-break: break-all;
  white-space: pre-line;
}
</style>
